import { AllDonorsResponseModel, DonorsResponseModel } from "@gtpl/shared-models/gtpl";
import { Body, Controller, Post, Req } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { DonorService } from "./donor.service";
import { DistrictReq } from "./dto/distirct-req";
import { DonorsDTO } from "./dto/donor.dto";

@ApiTags('donors')
@Controller('donors')
export class DonorController{
    constructor(
        private donorService : DonorService,
    ){}
    @Post('/createDonors')
    async createDonors(@Body() donorsDto:DonorsDTO,isUpdate:boolean=false): Promise<DonorsResponseModel> {
    try {
        return await this.donorService.createDonors(donorsDto, false);
      } catch (error) {
        throw new DonorsResponseModel(false,11104, 'Something wrong');
      }
    }
    @Post('/updateDonors')
    async updateDonors(@Body() donorsDto: DonorsDTO,@Req() request:Request): Promise<DonorsResponseModel> {
    try {
      return await this.donorService.createDonors(donorsDto, true);
    } catch (error) {
        throw new DonorsResponseModel(false,11104, 'Something wrong');
    }
  }
  @Post('/getAllDonors')
  async getAllDonors(): Promise<AllDonorsResponseModel> {
    try {
      return await this.donorService.getAllDonors();
    } catch (error) {
        throw new DonorsResponseModel(false,11104, 'Something wrong');
    }
  }
  @Post('/getConstituencyForDistirct')
  async getConstituencyForDistirct(@Body() req:DistrictReq): Promise<AllDonorsResponseModel> {
    try {
      return await this.donorService.getConstituencyForDistirct(req);
    } catch (error) {
      console.log(error)
        throw new DonorsResponseModel(false,11104, 'Something wrong');
    }
  }


}